export default "__VITE_ASSET__DgpbY8uv__"